import { Fragment } from "react";
import "./App.css";
import { Navbar, AllRoutes } from "./component";

function App() {
  return (
    <Fragment>
      <Navbar />
      <AllRoutes />
    </Fragment>
  );
}

export default App;
